import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto px-5">
        <div className="flex flex-col">
          <h3 className="mb-4 text-xl">TravelMaker</h3>
          <p>Your personal travel companion that makes exploring new cities easy and enjoyable.</p>
          {/* <div className="flex gap-4 mt-4">
            <a 
              href="https://facebook.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-2xl opacity-80 hover:opacity-100 transition-opacity duration-300"
            >
              📘
            </a>
            <a 
              href="https://twitter.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-2xl opacity-80 hover:opacity-100 transition-opacity duration-300"
            >
              🐦
            </a>
            <a 
              href="https://instagram.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-2xl opacity-80 hover:opacity-100 transition-opacity duration-300"
            >
              📷
            </a>
          </div> */}
        </div>

        <div className="flex flex-col">
          <h3 className="mb-4 text-xl">Links</h3>
          <Link to="/" className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300">
            Home
          </Link>
          <Link to="/about" className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300">
            About Us
          </Link>
          <Link to="/contact" className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300">
            Contact Us
          </Link>
        </div>

        <div className="flex flex-col">
          <h3 className="mb-4 text-xl">Legal</h3>
          <Link to="/privacy" className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300">
            Privacy Policy
          </Link>
          <Link to="/terms" className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300">
            Terms & Conditions
          </Link>
        </div>

        <div className="flex flex-col">
          <h3 className="mb-4 text-xl">Download</h3>
          <a
            href="https://apps.apple.com"
            target="_blank"
            rel="noopener noreferrer"
            className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300"
          >
            App Store
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.comrades.travelmaker"
            target="_blank"
            rel="noopener noreferrer"
            className="mb-2 opacity-80 hover:opacity-100 transition-opacity duration-300"
          >
            Google Play
          </a>
        </div>
      </div>

      <div className="text-center mt-8 pt-4 border-t border-white border-opacity-10 opacity-60 max-w-6xl mx-auto">
        <p>&copy; {new Date().getFullYear()} TravelMaker. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;